import gql from 'graphql-tag'

export default gql`mutation ycmdMessageConfirm($message_id: ID) {
	ycmdMessageConfirm(message_id: $message_id, client: "portal") {
		name
		value
	}
}`
